import React, { useMemo } from "react";

import { ButtonGroup, CheckBox } from "devextreme-react";
import TreeList, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
  Selection,
  TreeListRef,
} from "devextreme-react/tree-list";
import { useTranslation } from "react-i18next";

import { useWindowDimensions } from "@app/contexts";
import { SIZES } from "@app/state/constants";
import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { ieTreeItems } from "@app/statefx/schema/uiInvoiceEditing.def";
import { setIETreeState } from "@app/statefx/xThunks/uiInvoiceEditing";
import "@app/style/dx.generic.catetory-chooser-compact.css";
import "@app/style/dx.generic.catetory-chooser.css";

import "./ieSideTree.scss";

// import type { TTrackTreeItem } from "@app/state/insider/ui/invoiceTrack";
// const CHECKBOX_HEIGHT = 40;

export const IESideTree = () => {
  const once = React.useRef(false);
  const dispatch = useFxDispatch();
  const { t } = useTranslation();
  const { jgDrawerHeight } = useWindowDimensions();
  const treeRightRef = React.useRef<TreeListRef>(null);

  const currentState = useFxSelector(schema.uiInvoiceOverall.select);

  // const [nodeId, setNodeId] = useState<string[]>([]);
  // const [checkBoxValue, setCheckBoxValue] = useState<boolean>(false);
  //   const theTreeData = useFxSelector(fxInvoiceTrackTreeData) as TTrackTreeItem[];

  const nodeId = useMemo(() => [currentState?.currentItem], [currentState]);
  const checkBoxValue = useMemo(
    () => currentState?.includePrevious,
    [currentState]
  );

  function treeListOptionChange(e: any) {
    if (e.fullName === "selectedRowKeys") {
      const snodes = e.component.getSelectedRowKeys("excludeRecursive");
      //   setNodeId(snodes);
      dispatchStateChange(snodes[0]);
    }
  }

  const onNodeInitialized = (e: any) => {
    if (!once.current) {
      const lastItem = ieTreeItems.at(0);
      if (lastItem) {
        once.current = true;
        // if (treeRightRef.current?.instance) {
        //   treeRightRef.current.instance().beginUpdate();
        //   treeRightRef.current.instance().expandRow(`${lastItem.parent}`);
        //   treeRightRef.current.instance().expandRow(`${lastItem.id}`);
        //   treeRightRef.current.instance().endUpdate();
        // }
        dispatchStateChange(lastItem.id);
      }
    }
  };

  const draftCellRender = (e: any) => {
    return <div>{e?.data?.title}</div>;
  };

  const dispatchStateChange = (xNodeId: string) => {
    // dispatch(
    //   sfxPreserveTrackState({
    //     currentItem: xNodeId,
    //     includePrevious: xCheckBoxValue,
    //   })
    // );
    dispatch(setIETreeState({ currentTreeItemid: xNodeId }));
  };

  return (
    <TreeList
      id={"ieSideTree"}
      className={"dx-swatch-category-chooser"}
      ref={treeRightRef}
      height={jgDrawerHeight - 28}
      width={SIZES.headerButtonSize}
      dataSource={ieTreeItems}
      rootValue={null}
      keyExpr={"id"}
      parentIdExpr={"parent"}
      loadPanel={{ enabled: false }}
      selectedRowKeys={nodeId}
      noDataText={""}
      showColumnLines={false}
      showColumnHeaders={false}
      onOptionChanged={treeListOptionChange}
      onNodesInitialized={onNodeInitialized}
    >
      <Selection recursive={true} mode="single" />
      <SearchPanel visible={false} />
      <Scrolling
        showScrollbar={"always"}
        preloadEnabled={true}
        mode={"standard"}
        useNative={true}
      />{" "}
      {/* "standard"| "virtual" | "infinite" */}
      <HeaderFilter visible={false} />
      <Column
        dataField="title"
        caption={""}
        allowSorting={false}
        allowFiltering={false}
        cellRender={draftCellRender}
      />
    </TreeList>
  );
};
